import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Card, Col, Row, Form, Button, Spinner, FloatingLabel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import PageHeader from 'components/common/PageHeader';
import axios from 'axios';
import { toast } from 'react-toastify';
import { components } from "react-select";
import { InputGroup } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import IconAlert from 'components/common/IconAlert';
import $ from 'jquery';
import UploadFormFiles from 'components/common/UploadFormFiles';
import { useNavigate } from "react-router-dom";
import axiosInstance from 'helpers/axiosInstance';
import DatePicker, { registerLocale } from 'react-datepicker';


const CreateClientForm = (props, ref) => {

    useEffect(() => {
        const fetchNationalities = async () => {
            try {
                setIsLoadingNationalities(true);
                const response = await axiosInstance.get(`${window.location.origin}/parameters/countries`);
                setNationalityOptions(response.data);
            } catch (error) {
                console.error('Error loading nationalities:', error);
                toast.error('Error loading countries list', { theme: 'colored' });
            } finally {
                setIsLoadingNationalities(false);
            }
        };
        axiosInstance.get(`${window.location.origin}/parameters`).then((res) => {
            setAttachmentKind({ data: res.data.attachmentKinds.values });
        });

        fetchNationalities();
    }, []);

    useImperativeHandle(ref, () => ({
        save: async () => {
            handleSubmit();
        }
    }))

    // State
    let form = '';
    const [validated, setValidated] = useState(false);
    const [isLoadingNationalities, setIsLoadingNationalities] = useState(true);
    const [nationalityOptions, setNationalityOptions] = useState([]);
    const [selectedNationality, setSelectedNationality] = useState(null);
    const [selectedResidence, setSelectedResidence] = useState(null);
    const [attachmentKind, setAttachmentKind] = useState({ data: [] });
    const [activeClient, setActiveClient] = useState(false);

    const [physMet, setPhysMet] = useState(false);
    const [PEP, setPEP] = useState(false);
    const [specialTransac, setSpecialTransac] = useState(false);

    const [formData, setFormData] = useState({
        id: 0,
        company: '',
        nationalite: '',
        nationality: '',
        nationalityId: null,
        countryResidence: '',
        countryResidenceId: null,
        name: '',
        IBAN: '',
        SWIFT: '',
        address: '',
        bankAddress: '',
        kyc: false,
        notes: '',
        Risk: '',
        physMet: false,
        activeClient: false,
        PEP: false,
        specialTransac: false,
        NatureRelationshipCharter: false,
        NatureRelationshipSale: false,
        dateNextCheck: '',
        dateCheckedOn: '',
        ComplianceComment: ''
    });
    const [attachmentsData, setAttachmentsData] = useState({ data: [] });
    const { ValueContainer, Placeholder } = components;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showInvalidDateTooltip, setShowInvalidDateTooltip] = useState(false);

    //Handlers
    let navigate = useNavigate();
    const CustomValueContainer = ({ children, ...props }) => {
        return (
            <ValueContainer {...props}>
                <Placeholder {...props} isFocused={props.isFocused}>
                    {props.selectProps.placeholder}
                </Placeholder>
                {React.Children.map(children, (child) =>
                    child && child.type !== Placeholder ? child : null
                )}
            </ValueContainer>
        );
    };
    const loadOptionsFromCache = (inputValue) => {
        return Promise.resolve(
            nationalityOptions.filter(option =>
                option.residentName.toLowerCase().includes(inputValue.toLowerCase())
                || option.countryName.toLowerCase().includes(inputValue.toLowerCase())
            )
        );
    };

    const getDateColor = (nextCheck) => {
        if (!nextCheck || !(nextCheck instanceof Date)) return '';

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const oneMonthFromNow = new Date(today);
        oneMonthFromNow.setMonth(today.getMonth() + 1);

        const nextCheckDate = new Date(nextCheck);
        nextCheckDate.setHours(0, 0, 0, 0);

        if (nextCheckDate < today) {
            return ' text-danger input-danger';
        } else if (nextCheckDate <= oneMonthFromNow) {
            return ' text-warning input-warning';
        }
        return '';
    };

    const getKYCStatus = (kyc, nextCheck) => {
        if (!nextCheck || !(nextCheck instanceof Date)) return kyc;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const nextCheckDate = new Date(nextCheck);
        nextCheckDate.setHours(0, 0, 0, 0);
        return kyc && nextCheckDate >= today;
    };

    const calculateNextCheckDate = (checkedOnDate, riskLevel) => {
        if (!checkedOnDate) return null;

        const nextDate = new Date(checkedOnDate);
        nextDate.setHours(12, 0, 0, 0);

        const today = new Date();
        today.setHours(12, 0, 0, 0);

        switch (riskLevel) {
            case 'High':
                nextDate.setFullYear(nextDate.getFullYear() + 1);
                break;
            case 'Standard':
                nextDate.setFullYear(nextDate.getFullYear() + 2);
                break;
            case 'Low':
                nextDate.setFullYear(nextDate.getFullYear() + 3);
                break;
            default:
                return null;
        }

        return nextDate;
    };

    const handleSubmit = async (event) => {
        event?.preventDefault();
        if (isSubmitting) {
            return;
        }
        if (form.checkValidity() === false) {
            event?.preventDefault();
            event?.stopPropagation();
        }
        else {
            try {
                setIsSubmitting(true);
                $('.save-spinner').removeAttr('hidden');

                let res = await axiosInstance.post(`${window.location.origin}/clients`, formData);
                if (res.data) {
                    if (res.data.id !== '0') {
                        toast.success(`Client has been created.`, {
                            theme: 'colored'
                        });
                        if (attachmentsData.data.length != 0) {
                            const formData = new FormData();
                            for (let x = 0; x < attachmentsData.data.length; x++) {
                                let obj = attachmentsData.data[x];
                                formData.append("files[" + x + "].file", obj.theFile);
                                formData.append("files[" + x + "].type", obj.type);
                            }
                            formData.append("uploadTo", "client-" + res.data.id);
                            try {
                                const response = await axiosInstance.post(`${window.location.origin}/uploadFiles/multiple`, formData);

                                if (response.data && response.data.files) {
                                    const failedFiles = response.data.files.filter(file => !file.success);

                                    if (failedFiles.length > 0) {
                                        failedFiles.forEach(file => {
                                            toast.error(`${file.originalName}: ${file.errorMessage || file.warningMessage || "Échec du téléchargement"}`, {
                                                theme: 'colored',
                                                autoClose: 5000
                                            });
                                        });
                                    } else {
                                        toast.success("Files uploaded successfully.", {
                                            theme: 'colored'
                                        });
                                    }
                                } else {
                                    toast.success("Files uploaded successfully.", {
                                        theme: 'colored'
                                    });
                                }
                            } catch (error) {
                                console.error("Upload error:", error);
                                toast.error("Error uploading files", {
                                    theme: 'colored',
                                    autoClose: 5000
                                });
                                throw error;
                            }
                        }

                        if (props.InModal) {
                            props.onSave(res.data);
                        } else {
                            navigate("/components/clients/edit?id=" + res.data.id);
                        }
                    } else {
                        toast.error(`${res.data.message}`, {
                            theme: 'colored'
                        });
                        setIsSubmitting(false);
                    }

                    $('.save-spinner').attr('hidden', 'hidden');
                }
            }
            catch (error) {
                console.error('Error creating client:', error);
                toast.error('An error occurred while creating the client', { theme: 'colored' });
            } finally {
                setIsSubmitting(false);
                $('.save-spinner').attr('hidden', 'hidden');
            }
        }
        setValidated(true);
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    return (
        <>
            {
                props.InModal ? null :
                    <PageHeader className="mb-3 g-3" title="">
                        <div className="d-inline">
                            <h3 className="float-start">Create client</h3>
                            <div className="float-end">
                                <Button
                                    variant='falcon-primary'
                                    className='me-2'
                                    type="submit"
                                    disabled={isSubmitting}
                                    onClick={e => {
                                        if (!isSubmitting) {
                                            form.dispatchEvent(
                                                new Event("submit", { cancelable: true, bubbles: true })
                                            );
                                        }
                                    }}
                                >
                                    <Spinner animation="border" variant="primary" size="sm" hidden={!isSubmitting} className="save-spinner" />
                                    Save</Button>
                                <Button variant='falcon-warning' onClick={() => { window.history.back(); }}>
                                    <Spinner animation="border" variant="warning" role="status" size="sm" hidden={true} className="cancel-spinner" />
                                    Cancel</Button>
                            </div>
                        </div>
                    </PageHeader>
            }
            <Row className="mb-3 g-3">
                <Col lg={12}>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5>Client Details</h5>
                            <div className='d-flex'>
                                {/*<Form.Group as={Col} lg={4} className="mt-0">*/}
                                {/*	<div>*/}
                                {/*		<BootstrapSwitchButton*/}
                                {/*			type='switch'*/}
                                {/*			id='kyc'*/}
                                {/*			onlabel='KYC'*/}
                                {/*			offlabel='KYC'*/}
                                {/*			onstyle="primary"*/}
                                {/*			offstyle="light"*/}
                                {/*			width="100"*/}
                                {/*			checked={formData.kyc}*/}
                                {/*			onChange={(e) => {*/}
                                {/*				setFormData({ ...formData, "kyc": e });*/}
                                {/*			}} />*/}
                                {/*	</div>*/}
                                {/*</Form.Group>*/}
                            </div>
                        </Card.Header>
                        <Card.Body className="bg-light">
                            <Form validated={validated} onSubmit={handleSubmit} ref={ref => form = ref}>
                                <Row className="g-3">
                                    <FloatingLabel as={Col} lg={8}
                                        controlId="name"
                                        label="Client name"
                                    >
                                        <Form.Control
                                            type="text"
                                            value={formData.name}
                                            onChange={handleFieldChange}
                                            placeholder="Name"
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a client name.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                    {/*<FloatingLabel as={Col} lg={6}*/}
                                    {/*	controlId="nationalite"*/}
                                    {/*	label="Client nationality"*/}
                                    {/*>*/}
                                    {/*	<Form.Control*/}
                                    {/*		as="textarea"*/}
                                    {/*		value={formData.nationalite}*/}
                                    {/*		onChange={handleFieldChange}*/}
                                    {/*		placeholder="Nationality"*/}
                                    {/*	/>*/}
                                    {/*</FloatingLabel>*/}
                                    <Form.Group as={Col} lg={4}>
                                        <InputGroup className="h-100">
                                            <AsyncSelect
                                                isClearable={true}
                                                getOptionLabel={option => option.residentName}
                                                getOptionValue={option => option.id}
                                                value={selectedNationality}
                                                className="h-100 w-100 flex-fill w-50 fs--1rem"
                                                placeholder="Client nationality"
                                                loadOptions={loadOptionsFromCache}
                                                isLoading={isLoadingNationalities}
                                                defaultOptions={nationalityOptions}
                                                classNamePrefix="selectCustomFont"
                                                onChange={(selectedOption) => {
                                                    setSelectedNationality(selectedOption);
                                                    setFormData({
                                                        ...formData,
                                                        nationalityId: selectedOption ? selectedOption.id : null
                                                    });
                                                }}
                                                components={{
                                                    ValueContainer: CustomValueContainer
                                                }}
                                                styles={{
                                                    container: (baseStyles) => ({
                                                        ...baseStyles,
                                                    }),
                                                    valueContainer: (provided, state) => ({
                                                        ...provided,
                                                        overflow: "visible"
                                                    }),
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        height: '100%',
                                                    }),
                                                    menuList: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: 'white',
                                                    }),
                                                    placeholder: (provided, state) => ({
                                                        ...provided,
                                                        position: "absolute",
                                                        top: state.hasValue || state.selectProps.inputValue ? -10 : null,
                                                        backgroundColor:
                                                            state.hasValue || state.selectProps.inputValue
                                                                ? "transparent"
                                                                : "transparent",
                                                        transition: "top 0.1s, font-size 0.1s",
                                                        fontSize: state.hasValue || state.selectProps.inputValue ? 11.5 : 13,
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        transform: 'translateY(8px)'
                                                    }),
                                                    input: (base, state) => ({
                                                        ...base,
                                                        transform: state.hasValue || state.selectProps.inputValue ? 'translateY(8px)' : null
                                                    }),

                                                }}
                                            >
                                            </AsyncSelect>
                                        </InputGroup>
                                    </Form.Group>
                                    <FloatingLabel as={Col} lg={8}
                                        controlId="address"
                                        label="Client address"
                                    >
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            value={formData.address}
                                            onChange={handleFieldChange}
                                            placeholder="Address"
                                        />
                                    </FloatingLabel>
                                    <Form.Group as={Col} sm="auto" lg={4}>
                                        <InputGroup className="h-100">
                                            <AsyncSelect
                                                isClearable={true}
                                                getOptionLabel={option => option.countryName}
                                                getOptionValue={option => option.id}
                                                value={selectedResidence}
                                                className="h-100 w-100 flex-fill w-50 fs--1rem"
                                                placeholder="Client country of residence"
                                                loadOptions={loadOptionsFromCache}
                                                isLoading={isLoadingNationalities}
                                                defaultOptions={nationalityOptions}
                                                onChange={(selectedOption) => {
                                                    setSelectedResidence(selectedOption);
                                                    setFormData({
                                                        ...formData,
                                                        countryResidenceId: selectedOption ? selectedOption.id : null
                                                    });
                                                }}
                                                classNamePrefix="selectCustomFont"
                                                components={{
                                                    ValueContainer: CustomValueContainer
                                                }}
                                                styles={{
                                                    container: (baseStyles) => ({
                                                        ...baseStyles,
                                                    }),
                                                    valueContainer: (provided, state) => ({
                                                        ...provided,
                                                        overflow: "visible"
                                                    }),
                                                    control: (baseStyles) => ({
                                                        ...baseStyles,
                                                        height: '100%',
                                                    }),
                                                    menuList: (baseStyles) => ({
                                                        ...baseStyles,
                                                        backgroundColor: 'white',
                                                    }),
                                                    placeholder: (provided, state) => ({
                                                        ...provided,
                                                        position: "absolute",
                                                        top: state.hasValue || state.selectProps.inputValue ? -10 : null,
                                                        backgroundColor:
                                                            state.hasValue || state.selectProps.inputValue
                                                                ? "transparent"
                                                                : "transparent",
                                                        transition: "top 0.1s, font-size 0.1s",
                                                        fontSize: state.hasValue || state.selectProps.inputValue ? 11.5 : 13,
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        transform: 'translateY(8px)'
                                                    }),
                                                    input: (base, state) => ({
                                                        ...base,
                                                        transform: state.hasValue || state.selectProps.inputValue ? 'translateY(8px)' : null
                                                    }),

                                                }}

                                            >
                                            </AsyncSelect>
                                        </InputGroup>
                                    </Form.Group>
                                    <FloatingLabel as={Col} lg={8}
                                        controlId="IBAN"
                                        label="IBAN"
                                    >
                                        <Form.Control
                                            type="text"
                                            value={formData.IBAN}
                                            onChange={handleFieldChange}
                                            placeholder="IBAN"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a client IBAN.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                    <FloatingLabel as={Col} lg={4}
                                        controlId="SWIFT"
                                        label="SWIFT"
                                    >
                                        <Form.Control
                                            type="text"
                                            value={formData.SWIFT}
                                            onChange={handleFieldChange}
                                            placeholder="SWIFT"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a client SWIFT code.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                    <FloatingLabel as={Col} lg={12}
                                        controlId="bankAddress"
                                        label="Bank address"
                                    >
                                        <Form.Control
                                            as="textarea"
                                            value={formData.bankAddress}
                                            onChange={handleFieldChange}
                                            placeholder="Bank address"
                                        />
                                    </FloatingLabel>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={12}>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5>Compliance</h5>
                            <div className='d-flex'>
                                <Form.Group as={Col} lg={4} className="mt-0">
                                    <div className="position-relative d-inline-block">
                                        {getKYCStatus(true, formData.dateNextCheck) !== false ? (
                                            <BootstrapSwitchButton
                                                type='switch'
                                                id='kyc'
                                                onlabel='KYC'
                                                offlabel='KYC'
                                                onstyle="primary"
                                                offstyle="light"
                                                width="100"
                                                checked={formData.kyc}
                                                onChange={(e) => {
                                                    setFormData({ ...formData, "kyc": e });
                                                }}
                                            />
                                        ) : (
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="kyc-disabled-tooltip">
                                                        The KYC button is disabled because the 'Next documents check' date has passed.
                                                        Please update the documents and check dates to re-enable KYC.
                                                    </Tooltip>
                                                }
                                            >
                                                <div className="disabled-switch-wrapper">
                                                    <BootstrapSwitchButton
                                                        type='switch'
                                                        id='kyc-disabled'
                                                        onlabel='KYC'
                                                        offlabel='KYC'
                                                        onstyle="primary"
                                                        offstyle="light"
                                                        width="100"
                                                        checked={false}
                                                        onChange={() => { }}
                                                        style={{ opacity: 0.5, cursor: 'not-allowed' }}
                                                    />

                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            zIndex: 0,
                                                            background: '#c7c6c68c',
                                                            cursor: 'not-allowed'
                                                        }}
                                                    />
                                                </div>
                                            </OverlayTrigger>
                                        )}
                                    </div>
                                </Form.Group>
                            </div>
                        </Card.Header>
                        <Card.Body className="bg-light">
                            <Form validated={validated} onSubmit={handleSubmit} ref={ref => form = ref}>
                                <Row className="g-3 mx-3">
                                    <div className="col-5 d-flex flex-row mb-1 justify-content-between">
                                        <h6 className="mb-0">Active client</h6>
                                        <div className="d-flex">
                                            <Form.Check
                                                style={{ height: "1.5rem" }}
                                                type='switch'
                                                id='activeClient'
                                                className="mb-0"
                                                label={activeClient ? 'Yes' : 'No'}
                                                checked={activeClient}
                                                onChange={(e) => {
                                                    setActiveClient(e.target.checked);
                                                    setFormData({ ...formData, "activeClient": e.target.checked });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="g-3 mx-3">
                                    <div className="col-5 d-flex flex-row mb-1 justify-content-between">
                                        <h6 className="mb-0">Physically met</h6>
                                        <div className="d-flex">
                                            <Form.Check
                                                style={{ height: "1.5rem" }}
                                                type='switch'
                                                id='physMet'
                                                className="mb-0"
                                                label={physMet ? 'Yes' : 'No'}
                                                checked={physMet}
                                                onChange={(e) => {
                                                    setPhysMet(e.target.checked);
                                                    setFormData({ ...formData, "physMet": e.target.checked });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="g-3 mx-3">
                                    <div className="col-5 d-flex flex-row mb-1 justify-content-between">
                                        <h6 className="mb-0">PEP</h6>
                                        <div className="d-flex">
                                            <Form.Check
                                                style={{ height: "1.5rem" }}
                                                type='switch'
                                                id='PEP'
                                                className="mb-0"
                                                label={PEP ? 'Yes' : 'No'}
                                                checked={PEP}
                                                onChange={(e) => {
                                                    setPEP(e.target.checked);
                                                    setFormData({ ...formData, "PEP": e.target.checked });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="g-3 mx-3">
                                    <div className="col-5 d-flex flex-row mb-1 justify-content-between">
                                        <h6 className="mb-0">Special transaction deep examination</h6>
                                        <div className="d-flex">
                                            <Form.Check
                                                style={{ height: "1.5rem" }}
                                                type='switch'
                                                id='specialTransac'
                                                className="mb-0"
                                                label={specialTransac ? 'Yes' : 'No'}
                                                checked={specialTransac}
                                                onChange={(e) => {
                                                    setSpecialTransac(e.target.checked);
                                                    setFormData({ ...formData, "specialTransac": e.target.checked });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Row>
                                <div className="border-bottom border-dashed my-3"></div>
                                <Row>
                                    <div className="col-lg-8 col-sm-12">
                                        <Row className="g-3 mx-3">
                                            <div className="col-6">
                                                <fieldset>
                                                    <Form.Group as={Row} className="mb-3">
                                                        <Form.Label as="legend" className="h6 pt-0" column sm={2}>
                                                            Risk
                                                        </Form.Label>
                                                        <Col sm={10}>
                                                            <Form.Check
                                                                type="radio"
                                                                label="Low"
                                                                name="formHorizontalRadios"
                                                                id="formHorizontalRadios1"
                                                                checked={formData.Risk === "Low"}
                                                                onChange={(e) => {
                                                                    const nextCheckDate = calculateNextCheckDate(formData.dateCheckedOn, "Low");
                                                                    setFormData({
                                                                        ...formData,
                                                                        Risk: "Low",
                                                                        dateNextCheck: nextCheckDate
                                                                    });
                                                                }}
                                                            />
                                                            <Form.Check
                                                                type="radio"
                                                                label="Standard"
                                                                name="formHorizontalRadios"
                                                                id="formHorizontalRadios2"
                                                                checked={formData.Risk === "Standard"}
                                                                onChange={(e) => {
                                                                    const nextCheckDate = calculateNextCheckDate(formData.dateCheckedOn, "Standard");
                                                                    setFormData({
                                                                        ...formData,
                                                                        Risk: "Standard",
                                                                        dateNextCheck: nextCheckDate
                                                                    });
                                                                }}
                                                            />
                                                            <Form.Check
                                                                type="radio"
                                                                label="High"
                                                                name="formHorizontalRadios"
                                                                id="formHorizontalRadios3"
                                                                checked={formData.Risk === "High"}
                                                                onChange={(e) => {
                                                                    const nextCheckDate = calculateNextCheckDate(formData.dateCheckedOn, "High");
                                                                    setFormData({
                                                                        ...formData,
                                                                        Risk: "High",
                                                                        dateNextCheck: nextCheckDate
                                                                    });
                                                                }}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </fieldset>
                                            </div>
                                            <div className="col-6">
                                                <fieldset>
                                                    <Form.Group as={Row} className="mb-3">
                                                        <Form.Label as="legend" className="h6 pt-0" column>
                                                            Nature of relationship
                                                        </Form.Label>
                                                        <Col >
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="Charter"
                                                                id='charterCheck'
                                                                aria-labelledby="charterCheck"
                                                                checked={formData.NatureRelationshipCharter}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, "NatureRelationshipCharter": e.target.checked });
                                                                }}
                                                            />
                                                            <Form.Check
                                                                type="checkbox"
                                                                label="Sale"
                                                                id='SaleCheck'
                                                                aria-labelledby="SaleCheck"
                                                                checked={formData.NatureRelationshipSale}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, "NatureRelationshipSale": e.target.checked });
                                                                }}
                                                            />
                                                        </Col>
                                                    </Form.Group>
                                                </fieldset>
                                            </div>
                                        </Row>
                                        <Row className="g-3 mx-3 pt-1">
                                            <div className="col-6">
                                                <div className="row">
                                                    <div className="">
                                                        <label className="h6">Documents checked on</label>
                                                        <OverlayTrigger
                                                            placement="left-start"
                                                            overlay={
                                                                <Tooltip>
                                                                    Date cannot be set past the current day.
                                                                </Tooltip>
                                                            }
                                                            show={showInvalidDateTooltip}
                                                        >
                                                            <DatePicker
                                                                autoComplete='off'
                                                                selected={formData.dateCheckedOn}
                                                                onChange={(date) => {
                                                                    if (date) {
                                                                        date.setHours(12, 0, 0, 0);
                                                                        const nextCheckDate = calculateNextCheckDate(date, formData.Risk);
                                                                        setFormData({
                                                                            ...formData,
                                                                            dateCheckedOn: date,
                                                                            dateNextCheck: nextCheckDate
                                                                        });
                                                                    } else {
                                                                        setFormData({
                                                                            ...formData,
                                                                            dateCheckedOn: null,
                                                                            dateNextCheck: null
                                                                        });
                                                                    }
                                                                    setShowInvalidDateTooltip(false);
                                                                }}
                                                                maxDate={new Date()}
                                                                formatWeekDay={day => day.slice(0, 3)}
                                                                className='form-control unsetWidth'
                                                                value={formData.dateCheckedOn}
                                                                name="dateCheckedOn"
                                                                timeIntervals={5}
                                                                dateFormat="dd/MM/yyyy"
                                                                locale='es'
                                                                placeholderText="dd/mm/yy"
                                                                portalId="root-portal"
                                                                onCalendarOpen={() => setShowInvalidDateTooltip(false)}
                                                                onCalendarClose={() => setShowInvalidDateTooltip(false)}
                                                                onSelect={() => setShowInvalidDateTooltip(false)}
                                                                onInputClick={() => setShowInvalidDateTooltip(false)}
                                                                onDayMouseEnter={(day) => {
                                                                    const today = new Date();
                                                                    today.setHours(0, 0, 0, 0);
                                                                    if (day > today) {
                                                                        setShowInvalidDateTooltip(true);
                                                                    } else {
                                                                        setShowInvalidDateTooltip(false);
                                                                    }
                                                                }}
                                                            />
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="row">
                                                    <div className="">
                                                        <label className={`h6 ${getDateColor(formData.dateNextCheck)}`}>Next documents check</label>

                                                        <DatePicker
                                                            autoComplete='off'
                                                            selected={formData.dateNextCheck}
                                                            onChange={(date) => {
                                                                if (date) {
                                                                    date.setHours(12, 0, 0, 0);
                                                                }
                                                                setFormData({ ...formData, dateNextCheck: date });
                                                            }}
                                                            formatWeekDay={day => day.slice(0, 3)}
                                                            className={`form-control unsetWidth ${getDateColor(formData.dateNextCheck)}`}
                                                            value={formData.dateNextCheck}
                                                            minDate={new Date()}
                                                            name="dateNextCheck"
                                                            timeIntervals={5}
                                                            dateFormat="dd/MM/yyyy"
                                                            locale='es'
                                                            placeholderText="dd/mm/yy"
                                                            portalId="root-portal"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Row>
                                    </div>
                                    <div className="col-lg-4 col-sm-8 ps-lg-0 mt-sm-4 mt-lg-0">
                                        <div className="col-12">
                                            <IconAlert variant={"info"} className='mb-2'>
                                                <p className="mb-2" >The 'Next documents check' date is automatically calculated based on:</p>
                                                <p className="mb-3 ms-3">• 'Documents checked on' date<br />
                                                    • 'Risk' level selected:<br />
                                                    <p className="mb-0 ms-4">&nbsp;&nbsp;Low = +3 years</p>
                                                    <p className="mb-0 ms-4">&nbsp;&nbsp;Standard = +2 years</p>
                                                    <p className="mb-0 ms-4">&nbsp;&nbsp;High = +1 year</p></p>
                                                <p className="mb-0 font-italic font-weight-light" style={{ fontSize: "smaller", fontStyle: "italic" }}>
                                                    This field may also be manually adjusted if needed. Date cannot be set prior to the current day.</p>
                                            </IconAlert>
                                        </div>
                                    </div>
                                </Row>
                                <div className="border-bottom border-dashed my-3"></div>

                                <Row className="g-3">
                                    <Form.Group as={Col}>
                                        <FloatingLabel as={Col} lg={12}
                                            label="Compliance comments"
                                            className='h6 fw-bold fs-5'
                                        >
                                            <Form.Control
                                                style={{ minHeight: "150px" }}
                                                type="text"
                                                as="textarea"
                                                rows={5}
                                                value={formData.ComplianceComment}
                                                onChange={handleFieldChange}
                                                id="ComplianceComment"
                                            />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Row>

                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <UploadFormFiles
                attachmentsData={attachmentsData}
                attachmentKinds={attachmentKind}
                setAttachmentsData={setAttachmentsData}
            />
            <Col lg={12} className='mt-3 mb-3 g-3'>
                <Card>
                    <Card.Header className="bg-white">
                        <h5>Comments</h5>
                    </Card.Header>
                    <Card.Body className="bg-light">
                        <Form.Group as={Col}>
                            <Form.Control
                                style={{ minHeight: "150px" }}
                                type="text"
                                as="textarea"
                                rows={5}
                                value={formData.notes}
                                onChange={handleFieldChange}
                                id="notes"
                            />
                        </Form.Group>
                    </Card.Body>
                </Card>
            </Col>
        </>
    );
};

export default forwardRef(CreateClientForm);
